import React from "react";
import { useTranslation } from "react-i18next";

export const SettingsUploadHeaderErrorMessages = ({ message, code, data }) => {
  const { t } = useTranslation("dataUploads", { keyPrefix: "errors" });

  return (
    <React.Fragment>
      {message}
      <ul>
        {data.map(item => (
          <li>
            <b>{item.headerName}</b> {t("headerMappingIsMissing")}
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
};

export default SettingsUploadHeaderErrorMessages;
